import { render, staticRenderFns } from "./RecipeCostModal.vue?vue&type=template&id=3bf98bf9&scoped=true"
import script from "./RecipeCostModal.vue?vue&type=script&lang=js"
export * from "./RecipeCostModal.vue?vue&type=script&lang=js"
import style0 from "./RecipeCostModal.vue?vue&type=style&index=0&id=3bf98bf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf98bf9",
  null
  
)

export default component.exports